import { get } from 'lodash';
import { Fragment, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useCurrentUserContext } from '../../../../hooks/useCurrentUserContext/useCurrentUserContext';
import { useModal } from '../../../../hooks/useModal/useModal';
import { useWorkflowPathname } from '../../../../hooks/useWorkflowPathname/useWorkflowPathname';
import { ApplicationDataInterface } from '../../../../pages/Applications/applicationData.interface';
import useSubmissionStatusStore from '../../../../store/_legacy/submissionStatusStore/useSubmissionStatusStore';
import useAnalyticStore from '../../../../store/analyticStore/useAnalyticStore';
import { ContactUs } from '../../ContactUs/ContactUs';
import { FailedSubmissionActionCard } from '../FailedSubmissionActionCard/FailedSubmissionActionCard';

export const FailedSubmissionTaskCard = ({
  state,
}: {
  state: ApplicationDataInterface;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const workflowName = useWorkflowPathname();
  const [currentUser] = useCurrentUserContext();
  const { isShowing, open } = useModal();

  const { retryFailedSubmissionIsLoading, retryFailedSubmission } =
    useSubmissionStatusStore();

  const { sendApplicationTaskButtonClickedAnalytics } = useAnalyticStore();

  const applicationStatus = get(
    state,
    'currentVehicle.checklightSession.status',
  );

  const vehicleId = get(state, 'currentVehicle.id');

  const primaryButton = {
    name: 'retry',
    children: 'Retry',
    isDisabled: retryFailedSubmissionIsLoading,
    onClick: () => {
      sendApplicationTaskButtonClickedAnalytics(
        applicationStatus,
        primaryButton.children,
      );

      retryFailedSubmission(vehicleId);
    },
    order: 1,
  };

  const secondaryButton = {
    name: 'contactUs',
    children: 'Contact us',
    onClick: () => {
      sendApplicationTaskButtonClickedAnalytics(
        applicationStatus,
        secondaryButton.children,
      );

      open();
    },
    order: 2,
  };

  const taskButtons = useMemo(() => {
    return {
      secondaryButton,
      primaryButton,
    };
  }, [
    currentUser,
    location.pathname,
    navigate,
    open,
    primaryButton,
    secondaryButton.children,
    secondaryButton.name,
    state,
    workflowName,
  ]);

  return (
    <Fragment>
      <FailedSubmissionActionCard buttonGroup={taskButtons} />

      {isShowing && <ContactUs />}
    </Fragment>
  );
};
